(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/betslip/betslip-xpert-mode.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/betslip/betslip-xpert-mode.js');

'use strict';

const {
  useEffect,
  useState,
  forwardRef
} = React;
const Button = svs.ui.Button;
const {
  ReactIcon
} = svs.ui;
const {
  products
} = svs.utils;
const {
  Currency
} = svs.utils.format;
const {
  marketplace
} = svs.components;
const {
  AccountSelectorContainer,
  CommissionSelector,
  useAccount,
  payGame
} = marketplace.accountSelector;
const BetslipXpertMode = _ref => {
  let {
    getMeta,
    isDisabled,
    disabledReason,
    handlePayBtnClick,
    selectedAmount
  } = _ref;
  const ref = forwardRef();
  const [isIntersecting, setIsIntersecting] = useState(false);
  const isSelfService = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') && svs.core.config.data.svsconfig.isSelfService;
  const {
    marketplaceAccount,
    accountBalance,
    hasMarketplaceAccount
  } = useAccount(getMeta().drawNumber, products.productIds.RACING);
  useEffect(() => {
    if (isSelfService) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(_ref2 => {
          let {
            intersectionRatio
          } = _ref2;
          const isIntersectingNow = intersectionRatio > 0.05;
          isIntersecting(isIntersectingNow);
        });
      });
      if (ref.current) {
        observer.disconnect();
        observer.observe(ref.current);
      }
      return () => {
        observer.disconnect();
      };
    }
  }, [isIntersecting, setIsIntersecting, ref, isSelfService]);
  const paymentCallback = () => payGame({
    marketplaceAccount,
    drawNumber: getMeta().drawNumber,
    productId: products.productIds.RACING
  }, handlePayBtnClick);
  const payBtnTxt = isSelfService ? 'Lägg i Varukorg' : "Betala ".concat(Currency(selectedAmount), " kr");
  const renderBetslipFooterTag = () => React.createElement("div", {
    className: "betslip-footer-tag fixed"
  }, marketplaceAccount.name);
  return React.createElement("div", {
    className: "xpert-mode-betslip-container"
  }, marketplaceAccount && renderBetslipFooterTag(), hasMarketplaceAccount && React.createElement("div", {
    className: "account-selector-holder"
  }, svs.racing_game.data.isRetailerAdmin && React.createElement(CommissionSelector, {
    className: "padding"
  }), React.createElement(AccountSelectorContainer, null)), React.createElement("div", {
    className: "xpert-mode-betslip-holder"
  }, React.createElement("div", {
    className: "xpert-mode-betslip"
  }, React.createElement("div", {
    className: "f-center margin-bottom-1 margin-top-1"
  }, Boolean(accountBalance) && marketplaceAccount && "Saldo: ".concat(Currency(accountBalance), " kr")), React.createElement(Button, {
    className: "btn btn-300 btn-green btn-block center",
    disabled: selectedAmount === 0 || isDisabled,
    focus: true,
    onClick: paymentCallback,
    refs: ref
  }, payBtnTxt), isDisabled && React.createElement("div", {
    className: "error align-center"
  }, React.createElement(ReactIcon, {
    color: "fc-red",
    icon: "exclamation-sign",
    size: "300"
  }), React.createElement("div", {
    className: "fc-red"
  }, disabledReason)))));
};
BetslipXpertMode.defaultProps = {
  disabledReason: 'Loppet är tillfälligt stängt'
};
svs.racing_game.components.play.BetslipXpertMode = BetslipXpertMode;

 })(window);